import { NgModule } from '@angular/core';
import { AplicacionesService } from './aplicaciones.service';
import { CategoriasService } from './categorias.service';
import { GlobalService } from './global.service';
import { MarcasService } from './marcas.service';
import { ProductosService } from './productos.service';
import { SeriesService } from './series.service';
import { TiposDeProductosService } from './tipos-de-productos.service';

@NgModule({
	providers: [
		AplicacionesService,
		CategoriasService,
		GlobalService,
		MarcasService,
		ProductosService,
		SeriesService,
		TiposDeProductosService
	]
})
export class ServiciosModule { }